<template>
  <div class="homeBody">
    <Header ref="headers" />
    <div class="homeMain">
      <div class="stepHeadBox">
        <div class="back">
          <el-button type="text" @click="goBackRouter">{{returnText}}</el-button>
        </div>
      </div>
      <div class="homeTitle">
        <h2 v-if="param.isPersonAuth == 1">个人实名认证</h2>
        <h2 v-if="param.isPersonAuth == 0">企业实名认证 <span class="authStatusS" v-if="param.authSelectStatus == '5'||param.authSelectStatus == '7'">认证中</span><span class="authStatusF" v-else>未认证</span>
        </h2>
        <!-- <div>
          <el-button v-if="param.authSelectStatus == '5' || param.authSelectStatus === '7'" type="primary" @click="getRoute" size="medium">继续认证 </el-button>
          <el-button v-else type="primary" @click="getRoute" size="medium">开始认证 </el-button>
        </div> -->
      </div>
      <div class="homeNotice">
        <!-- <h3 class="noticeTitle">欢迎您使用豸信实名认证服务！请您先阅读须知：</h3> -->
        <div class="noticeMain" v-if="param.isPersonAuth ==1">
          <p>1、为满足业务需求，确保证书或电子签名的业务办理安全有效，需要您先进行个人实名认证，更好地保护您的合法权益；</p>
          <p>2、认证人年龄需满16周岁，同事目前仅支持持有如下证件类型的个人进行认证：
          <ul>
            <li>中国居民身份证</li>
          </ul>
          </p>
          <p>3、豸信CA向您保证您提交的身份信息仅用于实名认证以及数字证书的申请，未经您的许可，不会将您的身份信息用于其他用途；</p>
          <p>4、同时为准确验证您的身份，您授权豸信CA将您填写并提交的信息进行比对核验，以便豸信CA核验您的身份真实性；</p>
        </div>
        <div class="noticeMain" v-if="param.isPersonAuth ==0">
          <p>1、为满足业务需求，确保证书或电子印章为企业主体专有，需要您作为企业认证经办人版主企业进行实名认证，以更好地保护您的合法权益；</p>
          <p>2、仅支持中国大陆相关机构登记的以下类型主体进行认证：
          <ul>
            <li>企业法人</li>
            <li>个体工商户</li>
            <li>民办非企业单位、事业单位等其他组织或团体</li>
          </ul>
          </p>
          <p>3、豸信CA向您保证您提交的主体信息仅用于实名认证或申请数字证书，未经您的许可，不会将主体信息用于其他用途；</p>
          <p>4、同时为准确验证主体信息，您授权豸信CA将您填写并提交的信息进行比对核验，以便豸信CA核验企业信息的真实性；</p>
        </div>
      </div>
      <!-- <div class="homeState">
        <p>我已知悉上述内容并同意
          <el-button type="text" @click="goRouter('serviceAgreement')">《豸信CA实名认证服务协议》</el-button>
          <el-button type="text" @click="goRouter('certAgreement')">《数字证书申请及使用协议》</el-button>
          <el-button type="text" @click="goRouter('privacyPolicy')">《豸信CA隐私政策》</el-button>
        </p>
      </div> -->
      <div class="agreementsBottom">
        <p class="checkBox">
          <el-checkbox v-model="checked"></el-checkbox>我已知悉上述内容并同意
          <el-button type="text" @click="goRouter('serviceAgreement')">《豸信CA实名认证服务协议》</el-button>
          <el-button type="text" @click="goRouter('certAgreement')">《数字证书申请及使用协议》</el-button>
          <el-button type="text" @click="goRouter('privacyPolicy')">《豸信CA隐私政策》</el-button>
          <span v-if="!checked" class="checkTitle" :class="{animation:animation}">请确认并勾选协议</span>
        </p>
        <div class="lineBtn">
          <el-button v-if="param.authSelectStatus == '5' || param.authSelectStatus === '7'" type="primary" @click="getRoute" size="mini">继续认证 </el-button>
          <el-button v-else type="primary" @click="getRoute" size="mini">开始认证 </el-button>
          <!-- <el-button type="primary" size="mini" @click="getRoute">开始认证 </el-button> -->
        </div>
      </div>
    </div>
    <authResult :verifyMsg="verifyMsg" :indexBack="true" v-show="authCompletedShow" @blockFace="getBackStep"></authResult>
  </div>
</template>

<script>
import authResult from './company/authResult.vue'
import { setCssVar, setCssVarRGB } from '../utils/index'
export default {
  data() {
    return {
      checked: false,
      animation: false,
      param: {
        authMode: [],
        authSelectStatus: 0
      },
      authCompletedShow: false,
      verifyMsg: '',
      returnText: '',
      personAuthType: {}
    }
  },
  created() {},
  mounted() {
    var reg = /[?&]([^?&#]+)=([^?&#]+)/g
    this.param = {}
    var ret = reg.exec(window.location.href)
    while (ret) {
      // 当ret为null时表示已经匹配到最后了，直接跳出
      this.$set(this.param, ret[1], ret[2])
      ret = reg.exec(window.location.href)
    }
    this.$store.commit('SET_TOKEN', 'Bearer ' + this.param.token)
    this.getInfo()
  },
  components: {
    authResult
  },
  methods: {
    getInfo() {
      this.$api
        .getInfo({
          flowId: this.param.flowId
        })
        .then(res => {
          if (res.code === '0') {
            this.$set(this.param, 'authSelectMode', res.data.authMode) // 3法定代表人，4对公打款，我们打，5对公打款，对方打
            this.$set(this.param, 'authSelectStatus', res.data.authStep) // 状态 5进行中
            this.$set(this.param, 'havaAgentAuth', res.data.havaAgentAuth) // 是否经办人认证
            this.$set(this.param, 'canIssueCert', res.data.canIssueCert) // 是否下证
            this.$set(this.param, 'preWebUrl', res.data.preWebUrl) // 返回地址
            // 后端可能不返回 pageConfig，统一兜底为空对象，避免后续取值抛错中断 then 链
            const pageConfig = res.data?.pageConfig || {}
            this.$set(this.param, 'pageConfig', pageConfig) // 返回地址
            this.$set(this.param, 'useCustomInfo', res.data.useCustomInfo) // 使用自定义
            this.$set(this.param, 'agentAuthPassed', res.data.agentAuthPassed) // 代理人认证是否通过
            // 仅在后端返回时才覆盖，否则保留 Header 内建的默认 logo
            if (pageConfig.icon) this.$refs.headers.icon = pageConfig.icon
            if (pageConfig.titleText) this.$refs.headers.titleText = pageConfig.titleText
            this.returnText = '< ' + (pageConfig.returnText || '返回')
            setCssVar('--main-bg-color', pageConfig.themeColor || '')
            const RGBMian = setCssVarRGB(pageConfig.themeColor)
            setCssVar('--main-bgR-color', RGBMian[0] ?? '')
            setCssVar('--main-bgG-color', RGBMian[1] ?? '')
            setCssVar('--main-bgB-color', RGBMian[2] ?? '')

            this.$store.commit('SET_USERINFO', this.param)
            const remainAuthList = res.data.remainAuthTimeVOS || []
            remainAuthList.forEach(element => {
              this.personAuthType[element.authPath] = element.remainTime
            })
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.$store.commit('SET_USERINFO', this.param)
          if (err.code === '810404') {
            //810404当前没有可用的认证方式
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
          } else if (err.code === '810417') {
            this.verifyMsg = err.msg
            this.authCompletedShow = true
          } else {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {}
            })
          }
        })
    },
    goBackRouter() {
      window.location.href = this.$store.state.userInfo.preWebUrl
    },
    getBackStep() {
      this.countDown = 0
      this.authCompletedShow = false
      this.getInfo()
    },
    goRouter(val) {
      this.$router.push({ name: val })
    },
    getRoute() {
      if (!this.checked) {
        this.animation = true
        setTimeout(() => {
          this.animation = false
        }, 1500)
        return false
      }
      if (this.param.authSelectStatus === '5') {
        //认证中
        if (this.param.havaAgentAuth && !this.param.agentAuthPassed) {
          //代理人 havaAgentAuth是否有代理人  agentAuthPassed代理人是否认证成功
          this.$router.push({ name: 'companyAgentScanningCode' })
        } else if (this.param.authSelectMode === '3') {
          this.$router.push({ name: 'companyScanningCode' }) // 法定代表人
        } else if (this.param.authSelectMode === '4') {
          this.$router.push({ name: 'companySelectRemittanceType' }) //对公
        }
      } else if (this.param.authSelectStatus === '7') {
        if (this.param.havaAgentAuth && !this.param.agentAuthPassed) {
          // 代理人
          this.$router.push({ name: 'companyAgentScanningCode' })
        } else if (
          this.param.authSelectMode === '3' &&
          this.personAuthType['ENTERPRISE_LEGAL_PERSON']
        ) {
          this.$router.push({ name: 'companyScanningCode' }) // 法定代表人
        } else if (
          this.param.authSelectMode === '4' &&
          this.personAuthType['ENTERPRISE_BUSINESS_MAKE']
        ) {
          this.$router.push({ name: 'companySelectRemittanceType' }) //对公
        } else {
          this.$router.push({ name: 'companyEntryInfo' })
        }
      } else {
        // if (this.param.useCustomInfo) {
        //   //useCustomInfo 自定义信息
        //   this.$router.push({ name: 'companyEntryInfo' })
        // } else {
        // this.$router.push({ name: 'agreements' })
        if (this.param.isPersonAuth == 1) {
          this.$router.push({ name: 'personEntryInfo' })
        } else {
          this.$router.push({ name: 'companyEntryInfo' })
        }
        // }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.homeBody {
  background: #f1f3f7;
  position: relative;
}
.homeMain {
  width: 1600px;
  height: 850px;
  margin: 16px auto 0;
  background: #fff;
  .stepHeadBox {
    height: 50px;
    display: flex;
    justify-content: center;
    align-content: center;
    position: relative;
    .back {
      position: absolute;
      left: 20px;
      top: 2px;
    }
  }
  .homeTitle {
    display: flex;
    justify-content: flex-start;
    padding: 74px 0 21px 75px;
    h2 {
      font-size: 20px;
      font-weight: bold;
      padding-left: 34px;
      padding-right: 880px;
      background: url('../assets/img/managementCenter.png') no-repeat;
      background-size: 24px;
    }
    .el-button--medium {
      padding: 9px 16px;
      border-radius: 4px;
    }
    .authStatusS,
    .authStatusF {
      display: inline-block;
      width: 62px;
      height: 20px;
      background: #fff4e0 url(../assets/img/companyAuthstatusS.png) 6px center
        no-repeat;
      background-size: 10px 13px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #eea21f;
      line-height: 20px;
      padding-left: 20px;
    }
    .authStatusF {
      color: #333;
      background: #e9e9e9 url(../assets/img/companyAuthstatusF.png) 6px center
        no-repeat;
      background-size: 10px 13px;
    }
  }
  .homeNotice {
    padding: 0 75px;
    .noticeTitle {
      line-height: 68px;
      padding-left: 24px;
      background: url('../assets/img/notice.png') no-repeat 0 center;
      background-size: 16px;
      font-size: 14px;
      color: #333;
    }
    .noticeMain {
      width: 1552px;
      height: 309px;
      padding: 26px 0 0 24px;
      background: linear-gradient(
        266deg,
        rgba(241, 245, 255, 0) 0%,
        #f1f5ff 100%
      );
      border-radius: 4px;
      p {
        font-size: 12px;
        color: #333333;
        line-height: 16px;
        padding-bottom: 24px;
      }
      ul {
        padding-left: 20px;
      }
      li {
        padding-top: 16px;
        color: #595959;
        font-size: 12px;
        &::before {
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 6px;
          background: #d4d4d4;
          margin-right: 6px;
          vertical-align: middle;
        }
      }
    }
  }
  .homeState {
    margin: 0 25px;
    padding-left: 48px;
    h3 {
      font-size: 14px;
      color: #333;
    }
    p {
      font-size: 12px;
      line-height: 16px;
      color: #929292;
    }
    .el-button {
      padding: 0;
    }
    .el-button + .el-button {
      margin: 0;
    }
  }
}
.agreementsBottom {
  width: 1600px;
  background: #fff;
  margin: 70px auto 0px;
  text-align: center;
  .checkBox {
    position: relative;
    text-align: left;
    padding-left: 124px;
    padding-bottom: 70px;
  }
  .lineBtn {
    padding: 12px 0;
    text-align: center;
    .el-button {
      width: 91px;
      height: 36px;
      font-size: 14px;
      border-radius: 4px;
    }
  }
  .el-checkbox {
    margin-right: 5px;
  }
  .checkTitle {
    position: absolute;
    left: 68px;
    top: -36px;
    width: 122px;
    height: 38px;
    line-height: 38px;
    font-size: 12px;
    color: #fff;
    background: #595959;
    border-radius: 4px;
    text-align: center;
    &::before {
      position: absolute;
      bottom: -6px;
      left: 58px;
      content: '';
      border-top: 6px solid #595959;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }
    &.animation {
      animation: shake 0.5s;
    }
  }
}
@keyframes shake {
  0%,
  100% {
    transform: translate(0);
  }
  // 25%,
  // 75% {
  //   transform: translate(0, -8px);
  // }
  50% {
    transform: translate(0, 6px);
  }
}
</style>